var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      attrs: {
        editTitle: "Bankverbindung editieren",
        createTitle: "Neue Bankverbindung",
      },
    },
    [
      _c("table", [
        _c("tr", [
          _c("th", [
            _c("label", { staticClass: "label", attrs: { for: "iban" } }, [
              _vm._v("IBAN:"),
            ]),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.iban,
                    expression: "form.iban",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", id: "iban" },
                domProps: { value: _vm.form.iban },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "iban", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("label", { staticClass: "label", attrs: { for: "bic" } }, [
              _vm._v("BIC:"),
            ]),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.bic,
                    expression: "form.bic",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", id: "bic" },
                domProps: { value: _vm.form.bic },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "bic", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("label", { staticClass: "label", attrs: { for: "bank" } }, [
              _vm._v("Bank:"),
            ]),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.bank,
                    expression: "form.bank",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", id: "bank" },
                domProps: { value: _vm.form.bank },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "bank", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c(
              "label",
              { staticClass: "label", attrs: { for: "accountHolder" } },
              [_vm._v("Kontoinhaber:")]
            ),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.accountHolder,
                    expression: "form.accountHolder",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", id: "accountHolder" },
                domProps: { value: _vm.form.accountHolder },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "accountHolder", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", { staticClass: "is-top" }, [
            _c("label", { staticClass: "label", attrs: { for: "notes" } }, [
              _vm._v("Zusätzliche Notizen:"),
            ]),
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("tip-tap", {
                  model: {
                    value: _vm.form.notes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "notes", $$v)
                    },
                    expression: "form.notes",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c(
              "label",
              { staticClass: "label", attrs: { for: "primaryAccount" } },
              [_vm._v("Primärkonto:")]
            ),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "control" }, [
              _c("label", { staticClass: "radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.primaryAccount,
                      expression: "form.primaryAccount",
                    },
                  ],
                  attrs: { type: "radio" },
                  domProps: {
                    value: true,
                    checked: _vm._q(_vm.form.primaryAccount, true),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form, "primaryAccount", true)
                    },
                  },
                }),
                _vm._v("ja\n                   "),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.primaryAccount,
                      expression: "form.primaryAccount",
                    },
                  ],
                  attrs: { type: "radio" },
                  domProps: {
                    value: false,
                    checked: _vm._q(_vm.form.primaryAccount, false),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form, "primaryAccount", false)
                    },
                  },
                }),
                _vm._v("nein\n                   "),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }